inputs-without-label-typeahead
  .row
    .col-12
      input(type="hidden" name="{ opts.name }" value="{ opts.value }")
      input(class="form-control { opts.klass }" name="" placeholder="{ opts.placeholder }" type="text" value="{opts.text}" onInput="{this.onInput}" onChange="{this.onChange}" onFocus="{this.onFocus}" onBlur="{this.onBlur}")
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  .list.float(data-tag-scope="{this.tagScope}")
    ul(if="{this.isFocus}")
      li(each="{item, index in this.opts.candidates}" class="item {active: index === parent.index}" data-id="{item.id}" data-index="{index}" onMouseDown="{parent.onClickItem}") { item.name }
  script(type="typescript").
    this.mixin('inputs.typeahead');
